import { round } from 'lodash';
import { CalendarDay } from '../../../utils';
import { BridgeChartRow, FundValueBridgeData } from '../types';
import { BRIDGE_FIELDS } from './constants';

export type BuildChartDataParams = {
  bridge: FundValueBridgeData;
  periodStart: CalendarDay;
  periodEnd: CalendarDay;
};

const buildFundAssetValueLabel = (date: CalendarDay) =>
  `Fund asset value ${date.toReadable()}`;

const buildFundValueBridgeChartData = ({
  bridge,
  periodStart,
  periodEnd,
}: BuildChartDataParams): Array<BridgeChartRow> | null => {
  const visibleFields = BRIDGE_FIELDS.filter(
    (field) => field.isTotal === true || bridge[field.key] !== 0,
  );

  let runningTotal = 0;

  return visibleFields.map((field) => {
    const amount = bridge[field.key];
    const label = field.isStartTotal
      ? buildFundAssetValueLabel(periodStart)
      : field.isEndTotal
      ? buildFundAssetValueLabel(periodEnd)
      : field.label;

    if (field.isTotal) {
      runningTotal = amount;

      if (amount < 0) {
        return {
          key: field.key,
          label,
          displayValue: amount,
          base: amount,
          value: Math.abs(amount),
          isTotal: true,
        };
      }

      return {
        key: field.key,
        label,
        displayValue: amount,
        base: 0,
        value: amount,
        isTotal: true,
      };
    }

    const delta = amount;
    const isPositive = delta >= 0;
    const barHeight = Math.abs(delta);
    const base = isPositive ? runningTotal : round(runningTotal + delta, 2);
    runningTotal = round(runningTotal + delta, 2);

    return {
      key: field.key,
      label,
      displayValue: delta,
      base,
      value: barHeight,
      isTotal: false,
    };
  });
};

export default buildFundValueBridgeChartData;
